export const MP_COOKIE_NAME = 'MpConsentState';
export const CMP_UI_SHOWN = 'cmpuishown';
export const TCF_API_VERSION = 2;

export enum TENANT {
  MP = 'mp',
  TWH = 'twh',
}
